import React from 'react';
import styled from 'react-emotion';

const Icon = styled((props) => {
  const { className, ...rest } = props;
  return <i className={className} {...rest} />;
})`
  vertical-align: text-bottom;
`;

export default Icon;
